"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const theme_1 = __importDefault(require("../../../styles/theme"));
const loanStyles_1 = __importDefault(require("../../../features/loan/loanStyles"));
const installmentRows_1 = require("../../installmentRows/installmentRows");
const summaryRow_1 = __importDefault(require("../../summaryRow/summaryRow"));
const text_1 = __importStar(require("../../text/text"));
const messageCard_1 = __importDefault(require("../../messageCards/messageCard"));
const BankTransferView = ({ installment, bankName, bankAccountNumber, onPress }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(messageCard_1.default, { warning: {
                headline: 'When we receive your bank transfer, your amount due will be updated.',
            }, onPress: onPress }),
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: loanStyles_1.default.subtileMargin },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_GRAY_DARK }, t('bankTransferView.loan_payment'))),
            react_1.default.createElement(installmentRows_1.InstallmentItem, { id: installment.id, amount: installment.amount, penalty: installment.penalty, amountRemaining: installment.amount_remaining, status: installment.status, dateDue: installment.date_due }),
            installment.status !== 'PAID' && (react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(react_native_1.View, { style: loanStyles_1.default.activeLoansContainer },
                    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_GRAY_DARK }, t('bankTransferView.payment_bank_transfer'))),
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(summaryRow_1.default, { label: "BANK", value: bankName }),
                    react_1.default.createElement(summaryRow_1.default, { label: "ACCOUNT NUMBER", value: bankAccountNumber })))))));
};
exports.default = BankTransferView;
